import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack, Tooltip } from 'src/core/ui';
import { AnchorIcon } from 'src/svgs/AnchorIcon';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './GroupAnchor.css';

export const GroupAnchor = ({
  ltGroupName,
  isDarkMode,
}: {
  ltGroupName: string;
  isDarkMode: boolean;
}) => (
  <Tooltip
    contentVariant={isDarkMode ? 'light' : 'darkGray'}
    triggerContent={
      <Stack
        className={styles.anchorBadge}
        justifyContent="center"
        alignItems="center"
      >
        <AnchorIcon size={vars.iconSize.s} />
      </Stack>
    }
    align="center"
  >
    <div>
      <Content id={ContentId.MergeListingGroupTooltip} />{' '}
      <strong>{ltGroupName}</strong>
    </div>
  </Tooltip>
);
